
import { Injectable } from '@angular/core';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
declare const google: any;
declare let gapi: any;
@Injectable({
  providedIn: 'root',
})
export class GoogleAuthService {
  private clientId = '745090185837-mhhntiokkrk1mcr6e9kn8fika65ggg8j.apps.googleusercontent.com'; // Admin FlowTrics
  //private clientId = '693545091658-eu2frkl9nhj78aoagckuotfoeml1c9gq.apps.googleusercontent.com'; // Paul

  private gisAuthInstance: any;
  private accessToken: string | null = null;
  fileId:any;

  constructor( private _dataSharingService: DataSharingService) {}

  initializeAuth(): void {
    // Load the Google Identity Services library
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.onload = () => this.initializeGIS();
    document.body.appendChild(script);
  }

  private initializeGIS(): void {
    this.gisAuthInstance = google.accounts.oauth2.initTokenClient({
      client_id: this.clientId,
      scope: 'https://www.googleapis.com/auth/drive',
      callback: this.handleAuthResponse.bind(this),
    });
  }

  signIn(): void {
    if (!this.gisAuthInstance) {
      console.error('GIS not initialized');
      return;
    }
    this.gisAuthInstance.requestAccessToken();
  }

  private handleAuthResponse(response: any): void {
    if (response.error) {
      //console.error('Authentication failed', response.error);
      return;
    }
    this.accessToken = response.access_token
    //console.log('Access Token:', response.access_token);
    sessionStorage.setItem('access_token', response.access_token);
    this.openDrive();
  }

  getAccessToken(): string | null {
    return this.accessToken;
  }

  openDrive(): void {
    //const accessToken = this.authService.getAccessToken();
    const accessToken = sessionStorage.getItem('access_token');
    if (!accessToken) {
      alert('Please sign in first');
      return;
    }
    gapi.load('picker', () => {
      const picker = new google.picker.PickerBuilder()
        .addView(google.picker.ViewId.DOCS)
        //.enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setOAuthToken(this.accessToken) // Pass the OAuth token here
       // .setDeveloperKey('AIzaSyB4e2ulzqQW3n5nwV62sOnhlbMzwUX-Iug') //paul
        .setDeveloperKey('AIzaSyAgB9FEebHKjW6KsupYIm_il2vx9TqZM04') //Flowtrics
        //.setCallback(this.pickerCallback)
        .setCallback((data) => this.pickerCallback(data))
        .build();
      picker.setVisible(true);
    });   
  }

  
  pickerCallback(data: any) {
    var url="";
    if (data.action === google.picker.Action.PICKED) {    
      let doc = data[google.picker.Response.DOCUMENTS][0];
      url = doc[google.picker.Document.URL];
      this.fileId = data.docs[0].id;
      if(this.fileId){
        this.downloadFile(this.fileId,data.docs[0].name);
      }  
    } else {    
    }
  }

  

  
  downloadFile(fileId: string,selectedfileName:string) {
    const url = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;  
    const accessToken = sessionStorage.getItem('access_token');   
    fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((response) => response.blob())
      .then((blob) => {      
        const fileName = selectedfileName; // Replace with actual file name if available
        const file = this.convertBlobToFile(blob, fileName);
        this._dataSharingService.sendSelectedDocForGoogleDrive(file);
      })
      .catch((error) => console.error('Download error:', error));
  }

  convertBlobToFile(blob: Blob, fileName: string): File {
    // Add metadata for lastModifiedDate
    const lastModifiedDate = new Date();
    const file = new File([blob], fileName, {
      type: blob.type,
      lastModified: lastModifiedDate.getTime(),
    });  
    return file;
  }

  
}
